var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgDlsFallRisk = function SvgDlsFallRisk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 21h15v2H6zM5.764 4.41a1.863 1.863 0 01.749 2.531 1.869 1.869 0 01-2.536.748 1.863 1.863 0 01-.748-2.532 1.869 1.869 0 012.535-.747zM10.644 2l-1.694.799.95 2.008-1.773 1.34.009.014-2.302 2.877.01.01h-.01l.033 3.722-.004.005.004.004 2.75 2.518 1.264-1.378-2.152-1.97-.014-1.407 3.93 3.144-.005.009 2.353 2.443-1.446 3.063 1.694.799 1.997-4.222h-.005l.005-.005-3.382-3.526 1.165-1.453-.005-.004 3.027-2.56 3.227 1.364.73-1.719-4.262-1.802-.018-.019-.01.01-.018-.01-.019.037-4.168 3.494-2.83-2.26 2.563-1.944L10.643 2z"
  })));
};

export default __webpack_public_path__ + "static/media/DLS_Fall_risk.2b5062d7.svg";
export { SvgDlsFallRisk as ReactComponent };